import { render, staticRenderFns } from "./Pbos.vue?vue&type=template&id=02641434"
import script from "./Pbos.vue?vue&type=script&lang=js"
export * from "./Pbos.vue?vue&type=script&lang=js"
import style0 from "./Pbos.vue?vue&type=style&index=0&id=02641434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/user/src/app/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BCol, BFormSelect, BRow, BTable} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BCol, BFormSelect, BRow, BTable})
    

export default component.exports